import { render, staticRenderFns } from "./BreadcrumbsComponent.vue?vue&type=template&id=5f9d29fb"
import script from "./BreadcrumbsComponent.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports